/**
 * Estados de uma importação.
 *
 * ```text
 * UPLOADED → PARSED → MAPPED → VALIDATED → CONFIRMED
 *                                       ↘ CANCELLED
 * ```
 *
 * `CONFIRMED` é terminal e imutável (RN-039): reconfirmar duplicaria o efeito de uma
 * planilha que já entrou. Para corrigir, importa-se de novo — e a reimportação atualiza
 * as linhas em vez de duplicá-las (RN-032).
 */
export type ScheduleImportStatus =
  'UPLOADED' | 'PARSED' | 'MAPPED' | 'VALIDATED' | 'CONFIRMED' | 'CANCELLED' | 'FAILED';

export type ScheduleImportRowStatus =
  'PENDING' | 'VALID' | 'WARNING' | 'INVALID' | 'DUPLICATE' | 'IGNORED';

export const IMPORT_STATUS_LABEL: Readonly<Record<ScheduleImportStatus, string>> = {
  UPLOADED: 'Enviada',
  PARSED: 'Lida',
  MAPPED: 'Mapeada',
  VALIDATED: 'Conferida',
  CONFIRMED: 'Importada',
  CANCELLED: 'Cancelada',
  FAILED: 'Falhou',
};

/** Importação encerrada não recebe mais nada — nem confirmação, nem revalidação. */
export function isClosed(status: ScheduleImportStatus): boolean {
  return status === 'CONFIRMED' || status === 'CANCELLED' || status === 'FAILED';
}
